import {
  Box,
  Stack,
  NumericInput,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { PercentIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import { DatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';

import { useSecurityDepositInterestRateEditableRow } from './hooks';

const EditableRow = ({
  newInterestRatesToCreate,
  interestRate,
  setNewInterestRatesToCreate,
  alreadyExistingRates,
  setAlreadyExistingRates,
  idx,
  id,
  setModifiedRates,
}) => {
  const {
    startDateInvalid,
    handleStartDateChange,
    shouldDisableStartDate,
    handleEndDateChange,
    shouldDisableEndDate,
    handleInterestRateChange,
    interestRateInvalid,
  } = useSecurityDepositInterestRateEditableRow({
    newInterestRatesToCreate,
    interestRate,
    setNewInterestRatesToCreate,
    alreadyExistingRates,
    setAlreadyExistingRates,
    idx,
    id,
    setModifiedRates,
  });

  return (
    <Stack direction={'row'} spacing={4}>
      <Box sx={{ flex: 1 }} onKeyDown={(e) => e.preventDefault()}>
        <DatePicker
          error={startDateInvalid}
          onChange={handleStartDateChange}
          value={interestRate.startDate}
          shouldDisableDate={shouldDisableStartDate}
          required={startDateInvalid}
          disabled={!interestRate.startDateIsEditable}
        />
      </Box>
      <Box sx={{ flex: 1 }} onKeyDown={(e) => e.preventDefault()}>
        <DatePicker
          onChange={handleEndDateChange}
          value={interestRate.endDate}
          shouldDisableDate={shouldDisableEndDate}
          disabled={!interestRate.endDateIsEditable}
        />
      </Box>
      <Box sx={{ flex: 1 }}>
        <NumericInput
          adornment={<PercentIcon />}
          onChange={handleInterestRateChange}
          value={interestRate.interest}
          placeholder="0 %"
          required={interestRateInvalid}
          error={interestRateInvalid}
          step={0.01}
          max={10}
          min={0}
        />
      </Box>
    </Stack>
  );
};

export default EditableRow;
